import React, { useRef, useState } from "react";
import ariesImage from "../assets/AiImage/aries.png";
import taurusImage from "../assets/AiImage/taurus1.png";
import geminiImage from "../assets/AiImage/gemini1.png";
import cancerImage from "../assets/AiImage/cancer.png";
import leoImage from "../assets/AiImage/leo.png";
import virgoImage from "../assets/AiImage/virgo.png";
import libraImage from "../assets/AiImage/libra.png";
import scorpioImage from "../assets/AiImage/scorpio.png";
import sagittariusImage from "../assets/AiImage/Sagittarius.png";
import capricornImage from "../assets/AiImage/Capricorn.png";
import aquariusImage from "../assets/AiImage/aquarius1.png";
import piscesImage from "../assets/AiImage/pisces1.png";
import rings from "../assets/rootimg/two-rings.png";
import dailyHoroscope from "../assets/rootimg/kundlicomp.png";
import dailytarotImage from "../assets/zodiacSign/dailytarot.png";
import lover from "../assets/zodiacimage/lover.png";
import { MdOutlineKeyboardArrowRight, MdOutlineKeyboardArrowLeft } from "react-icons/md";
import Footer from '../home/Footer';
import Queryform from './Queryform';
import { Link, useNavigate } from "react-router";
import { FaChevronRight } from "react-icons/fa";
import Navbar from "../home/Navbar";
import { API_URL } from "./Utils/Constant";

const LoveCompatibility = () => {
    const zodiacSigns = [
        { name: 'Aries', date: 'Mar 21 - Apr 19', image: ariesImage },
        { name: 'Taurus', date: 'Apr 20 - May 20', image: taurusImage },
        { name: 'Gemini', date: 'May 21 - Jun 20', image: geminiImage },
        { name: 'Cancer', date: 'Jun 21 - Jul 22', image: cancerImage },
        { name: 'Leo', date: 'Jul 23 - Aug 22', image: leoImage },
        { name: 'Virgo', date: 'Aug 23 - Sep 22', image: virgoImage },
        { name: 'Libra', date: 'Sep 23 - Oct 22', image: libraImage },
        { name: 'Scorpio', date: 'Oct 23 - Nov 21', image: scorpioImage },
        { name: 'Sagittarius', date: 'Nov 22 - Dec 21', image: sagittariusImage },
        { name: 'Capricorn', date: 'Dec 22 - Jan 19', image: capricornImage },
        { name: 'Aquarius', date: 'Jan 20 - Feb 18', image: aquariusImage },
        { name: 'Pisces', date: 'Feb 19 - Mar 20', image: piscesImage },
    ];
    const compatibilityGroups = {
        Taurus: [
            { pair: 'Taurus & Leo', image: taurusImage, image1: leoImage },
            { pair: 'Taurus & Sagittarius', image: taurusImage, image1: sagittariusImage },
            { pair: 'Taurus & Capricorn', image: taurusImage, image1: capricornImage },
            { pair: 'Taurus & Cancer', image: taurusImage, image1: cancerImage },
            { pair: 'Taurus & Scorpio', image: taurusImage, image1: scorpioImage },
            { pair: 'Taurus & Pisces', image: taurusImage, image1: piscesImage },
            { pair: 'Taurus & Aquarius', image: taurusImage, image1: aquariusImage },
            { pair: 'Taurus & Virgo', image: taurusImage, image1: virgoImage },
            { pair: 'Taurus & Libra', image: taurusImage, image1: libraImage },
            { pair: 'Taurus & Aries', image: taurusImage, image1: ariesImage },
            { pair: 'Taurus & Taurus', image: taurusImage, image1: taurusImage },
            { pair: 'Taurus & Gemini', image: taurusImage, image1: geminiImage },
        ],
        Aries: [
            { pair: 'Aries & Capricorn', image: ariesImage, image1: capricornImage },
            { pair: 'Aries & Aquarius', image: ariesImage, image1: aquariusImage },
            { pair: 'Aries & Virgo', image: ariesImage, image1: virgoImage },
            { pair: 'Aries & Libra', image: ariesImage, image1: libraImage },
            { pair: 'Aries & Scorpio', image: ariesImage, image1: scorpioImage },
            { pair: 'Aries & Aries', image: ariesImage, image1: ariesImage },
            { pair: 'Aries & Taurus', image: ariesImage, image1: taurusImage },
            { pair: 'Aries & Gemini', image: ariesImage, image1: geminiImage },
            { pair: 'Aries & Cancer', image: ariesImage, image1: cancerImage },
            { pair: 'Aries & Leo', image: ariesImage, image1: leoImage },
            { pair: 'Aries & Sagittarius', image: ariesImage, image1: sagittariusImage },
            { pair: 'Aries & Pisces', image: ariesImage, image1: piscesImage },
        ],
        Gemini: [
            { pair: 'Gemini & Aries', image: geminiImage, image1: ariesImage },
            { pair: 'Gemini & Virgo', image: geminiImage, image1: virgoImage },
            { pair: 'Gemini & Libra', image: geminiImage, image1: libraImage },
            { pair: 'Gemini & Scorpio', image: geminiImage, image1: scorpioImage },
            { pair: 'Gemini & Capricorn', image: geminiImage, image1: capricornImage },
            { pair: 'Gemini & Taurus', image: geminiImage, image1: taurusImage },
            { pair: 'Gemini & Sagittarius', image: geminiImage, image1: sagittariusImage },
            { pair: 'Gemini & Cancer', image: geminiImage, image1: cancerImage },
            { pair: 'Gemini & Leo', image: geminiImage, image1: leoImage },
            { pair: 'Gemini & Gemini', image: geminiImage, image1: geminiImage },
            { pair: 'Gemini & Pisces', image: geminiImage, image1: piscesImage },
            { pair: 'Gemini & Aquarius', image: geminiImage, image1: aquariusImage },
        ],
        Cancer: [
            { pair: 'Cancer & Cancer', image: cancerImage, image1: cancerImage },
            { pair: 'Cancer & Scorpio', image: cancerImage, image1: scorpioImage },
            { pair: 'Cancer & Sagittarius', image: cancerImage, image1: sagittariusImage },
            { pair: 'Cancer & Leo', image: cancerImage, image1: leoImage },
            { pair: 'Cancer & Virgo', image: cancerImage, image1: virgoImage },
            { pair: 'Cancer & Libra', image: cancerImage, image1: libraImage },
            { pair: 'Cancer & Gemini', image: cancerImage, image1: geminiImage },
            { pair: 'Cancer & Aquarius', image: cancerImage, image1: aquariusImage },
            { pair: 'Cancer & Capricorn', image: cancerImage, image1: capricornImage },
            { pair: 'Cancer & Aries', image: cancerImage, image1: ariesImage },
            { pair: 'Cancer & Taurus', image: cancerImage, image1: taurusImage },
            { pair: 'Cancer & Pisces', image: cancerImage, image1: piscesImage },
        ],
        Leo: [
            { pair: 'Leo & Taurus', image: leoImage, image1: taurusImage },
            { pair: 'Leo & Capricorn', image: leoImage, image1: capricornImage },
            { pair: 'Leo & Aquarius', image: leoImage, image1: aquariusImage },
            { pair: 'Leo & Aries', image: leoImage, image1: ariesImage },
            { pair: 'Leo & Leo', image: leoImage, image1: leoImage },
            { pair: 'Leo & Virgo', image: leoImage, image1: virgoImage },
            { pair: 'Leo & Pisces', image: leoImage, image1: piscesImage },
            { pair: 'Leo & Gemini', image: leoImage, image1: geminiImage },
            { pair: 'Leo & Cancer', image: leoImage, image1: cancerImage },
            { pair: 'Leo & Libra', image: leoImage, image1: libraImage },
            { pair: 'Leo & Scorpio', image: leoImage, image1: scorpioImage },
            { pair: 'Leo & Sagittarius', image: leoImage, image1: sagittariusImage },
        ],
        Virgo: [
            { pair: 'Virgo & Aries', image: virgoImage, image1: ariesImage },
            { pair: 'Virgo & Capricorn', image: virgoImage, image1: capricornImage },
            { pair: 'Virgo & Aquarius', image: virgoImage, image1: aquariusImage },
            { pair: 'Virgo & Taurus', image: virgoImage, image1: taurusImage },
            { pair: 'Virgo & Pisces', image: virgoImage, image1: piscesImage },
            { pair: 'Virgo & Scorpio', image: virgoImage, image1: scorpioImage },
            { pair: 'Virgo & Gemini', image: virgoImage, image1: geminiImage },
            { pair: 'Virgo & Cancer', image: virgoImage, image1: cancerImage },
            { pair: 'Virgo & Sagittarius', image: virgoImage, image1: sagittariusImage },
            { pair: 'Virgo & Leo', image: virgoImage, image1: leoImage },
            { pair: 'Virgo & Virgo', image: virgoImage, image1: virgoImage },
            { pair: 'Virgo & Libra', image: virgoImage, image1: libraImage },
        ],
        Libra: [
            { pair: 'Libra & Virgo', image: libraImage, image1: virgoImage },
            { pair: 'Libra & Capricorn', image: libraImage, image1: capricornImage },
            { pair: 'Libra & Aquarius', image: libraImage, image1: aquariusImage },
            { pair: 'Libra & Aries', image: libraImage, image1: ariesImage },
            { pair: 'Libra & Taurus', image: libraImage, image1: taurusImage },
            { pair: 'Libra & Leo', image: libraImage, image1: leoImage },
            { pair: 'Libra & Pisces', image: libraImage, image1: piscesImage },
            { pair: 'Libra & Libra', image: libraImage, image1: libraImage },
            { pair: 'Libra & Gemini', image: libraImage, image1: geminiImage },
            { pair: 'Libra & Cancer', image: libraImage, image1: cancerImage },
            { pair: 'Libra & Sagittarius', image: libraImage, image1: sagittariusImage },
            { pair: 'Libra & Scorpio', image: libraImage, image1: scorpioImage },
        ],
        Scorpio: [
            { pair: 'Scorpio & Libra', image: scorpioImage, image1: libraImage },
            { pair: 'Scorpio & Capricorn', image: scorpioImage, image1: capricornImage },
            { pair: 'Scorpio & Cancer', image: scorpioImage, image1: cancerImage },
            { pair: 'Scorpio & Leo', image: scorpioImage, image1: leoImage },
            { pair: 'Scorpio & Virgo', image: scorpioImage, image1: virgoImage },
            { pair: 'Scorpio & Aquarius', image: scorpioImage, image1: aquariusImage },
            { pair: 'Scorpio & Aries', image: scorpioImage, image1: ariesImage },
            { pair: 'Scorpio & Taurus', image: scorpioImage, image1: taurusImage },
            { pair: 'Scorpio & Gemini', image: scorpioImage, image1: geminiImage },
            { pair: 'Scorpio & Pisces', image: scorpioImage, image1: piscesImage },
            { pair: 'Scorpio & Scorpio', image: scorpioImage, image1: scorpioImage },
            { pair: 'Scorpio & Sagittarius', image: scorpioImage, image1: sagittariusImage },
        ],
        Sagittarius: [
            { pair: 'Sagittarius & Leo', image: sagittariusImage, image1: leoImage },
            { pair: 'Sagittarius & Aries', image: sagittariusImage, image1: ariesImage },
            { pair: 'Sagittarius & Taurus', image: sagittariusImage, image1: taurusImage },
            { pair: 'Sagittarius & Scorpio', image: sagittariusImage, image1: scorpioImage },
            { pair: 'Sagittarius & Sagittarius', image: sagittariusImage, image1: sagittariusImage },
            { pair: 'Sagittarius & Capricorn', image: sagittariusImage, image1: capricornImage },
            { pair: 'Sagittarius & Aquarius', image: sagittariusImage, image1: aquariusImage },
            { pair: 'Sagittarius & Pisces', image: sagittariusImage, image1: piscesImage },
            { pair: 'Sagittarius & Gemini', image: sagittariusImage, image1: geminiImage },
            { pair: 'Sagittarius & Cancer', image: sagittariusImage, image1: cancerImage },
            { pair: 'Sagittarius & Virgo', image: sagittariusImage, image1: virgoImage },
            { pair: 'Sagittarius & Libra', image: sagittariusImage, image1: libraImage },
        ],
        Capricorn: [
            { pair: 'Capricorn & Cancer', image: capricornImage, image1: cancerImage },
            { pair: 'Capricorn & Capricorn', image: capricornImage, image1: capricornImage },
            { pair: 'Capricorn & Aquarius', image: capricornImage, image1: aquariusImage },
            { pair: 'Capricorn & Aries', image: capricornImage, image1: ariesImage },
            { pair: 'Capricorn & Scorpio', image: capricornImage, image1: scorpioImage },
            { pair: 'Capricorn & Taurus', image: capricornImage, image1: taurusImage },
            { pair: 'Capricorn & Gemini', image: capricornImage, image1: geminiImage },
            { pair: 'Capricorn & Libra', image: capricornImage, image1: libraImage },
            { pair: 'Capricorn & Pisces', image: capricornImage, image1: piscesImage },
            { pair: 'Capricorn & Virgo', image: capricornImage, image1: virgoImage },
            { pair: 'Capricorn & Leo', image: capricornImage, image1: leoImage },
            { pair: 'Capricorn & Sagittarius', image: capricornImage, image1: sagittariusImage },
        ],
        Aquarius: [
            { pair: 'Aquarius & Aries', image: aquariusImage, image1: ariesImage },
            { pair: 'Aquarius & Taurus', image: aquariusImage, image1: taurusImage },
            { pair: 'Aquarius & Capricorn', image: aquariusImage, image1: capricornImage },
            { pair: 'Aquarius & Aquarius', image: aquariusImage, image1: aquariusImage },
            { pair: 'Aquarius & Scorpio', image: aquariusImage, image1: scorpioImage },
            { pair: 'Aquarius & Sagittarius', image: aquariusImage, image1: sagittariusImage },
            { pair: 'Aquarius & Pisces', image: aquariusImage, image1: piscesImage },
            { pair: 'Aquarius & Gemini', image: aquariusImage, image1: geminiImage },
            { pair: 'Aquarius & Libra', image: aquariusImage, image1: libraImage },
            { pair: 'Aquarius & Leo', image: aquariusImage, image1: leoImage },
            { pair: 'Aquarius & Cancer', image: aquariusImage, image1: cancerImage },
            { pair: 'Aquarius & Virgo', image: aquariusImage, image1: virgoImage },
        ],
        Pisces: [
            { pair: 'Pisces & Libra', image: piscesImage, image1: libraImage },
            { pair: 'Pisces & Scorpio', image: piscesImage, image1: scorpioImage },
            { pair: 'Pisces & Sagittarius', image: piscesImage, image1: sagittariusImage },
            { pair: 'Pisces & Capricorn', image: piscesImage, image1: capricornImage },
            { pair: 'Pisces & Cancer', image: piscesImage, image1: cancerImage },
            { pair: 'Pisces & Leo', image: piscesImage, image1: leoImage },
            { pair: 'Pisces & Virgo', image: piscesImage, image1: virgoImage },
            { pair: 'Pisces & Capricorn', image: piscesImage, image1: aquariusImage },
            { pair: 'Pisces & Capricorn', image: piscesImage, image1: piscesImage },
            { pair: 'Pisces & Taurus', image: piscesImage, image1: taurusImage },
            { pair: 'Pisces & Aries', image: piscesImage, image1: ariesImage },
            { pair: 'Pisces & Gemini', image: piscesImage, image1: geminiImage },
        ]
    };
    // State for the current zodiac group
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isActive, setIsActive] = useState(null);
    const groupKeys = Object.keys(compatibilityGroups);

    const handleNext = () => {
        setCurrentIndex((prevIndex) => {
            const nextIndex = (prevIndex + 1) % groupKeys.length;
            setCurrentGroupName(groupKeys[nextIndex]);
            setCurrentGroupPairs(compatibilityGroups[groupKeys[nextIndex]]);
            return nextIndex;
        });
    };

    const handlePrev = () => {
        setCurrentIndex((prevIndex) => {
            const nextIndex = prevIndex === 0 ? groupKeys.length - 1 : prevIndex - 1;
            setCurrentGroupName(groupKeys[nextIndex]);
            setCurrentGroupPairs(compatibilityGroups[groupKeys[nextIndex]]);
            return nextIndex;
        });
    };

    // Get current group data

    const [currentGroupName, setCurrentGroupName] = useState("Aries");
    const [currentGroupPairs, setCurrentGroupPairs] = useState(
        compatibilityGroups["Aries"] || []
    );

    const compatibilitySectionRef = useRef(null);

    const handleSignClick = (signName) => {
        const groupData = compatibilityGroups[signName] || [];
        setCurrentGroupName(signName);
        setCurrentGroupPairs(groupData);
        compatibilitySectionRef.current.scrollIntoView({ behavior: "smooth" });
    };
    const navigate = useNavigate();
    const kundliClick = (e) => {
        e.preventDefault();
        navigate('/kundlimatching');
    }
    const tarotClick = (e) => {
        e.preventDefault();
        navigate('/tarot');
    }
    const horoscopeClick = (e) => {
        e.preventDefault();
        navigate('/horoscope');
    }
    const handleButtonClick = async (signPair) => {
        const [yourSign, partnerSign] = signPair.split(' & ');

        try {
            // Send the selected sign pair as part of an array
            const sign_pairs = [`${yourSign} & ${partnerSign}`];

            const response = await fetch(`${API_URL}compatibility/get-lovepredictions`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ sign_pairs })  // Send sign pairs as an array
            });

            const data = await response.json();
            // console.log('Response from backend:', data);

            if (data && data.length > 0) {
                // Navigate to the result page and pass prediction data
                navigate('/love-compatibility-result', { state: { prediction: data[0].prediction, yourSign, partnerSign } });
            } else {
                alert('No predictions found for this pair.');
            }
        } catch (error) {
            console.error('Error during API request:', error);
        }
    };

    return (
        <>
            <section className="bg-gradient-to-r from-white to-gray-300/80 text-gray-900 min-h-screen">
                <Navbar />
                <div className="w-full max-w-3xl text-sm text-gray-600 flex flex-wrap justify-center sm:justify-start items-center mt-6 px-4 sm:px-8">
                    <Link to="/" className="text-secondary hover:underline">
                        HOME
                    </Link>
                    <FaChevronRight className="mx-2 text-gray-500" />

                    <Link to="/compatibility" className="text-secondary hover:underline">
                        COMPATIBILITY
                    </Link>
                    <FaChevronRight className="mx-2 text-gray-500" />

                    <span className="text-gray-700 font-semibold">LOVE COMPATIBILITY</span>
                </div>
                <div className="text-gray-900 flex flex-col items-center py-12">
                    {/* Heading */}
                    <div className="flex flex-col sm:flex-row items-center text-center sm:text-left">
                        <img src={lover} alt="bull.png" className="w-6 h-6 sm:w-8 sm:h-8 mr-2 mb-2 object-cover" />
                        <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold font-serif text-secondary mb-2">
                            LOVE COMPATIBILITY
                        </h1>
                    </div>
                    <p className="text-lg text-secondary text-center max-w-4xl">
                        Discover if you and your partner are soulmates, best friends, or perhaps a recipe for chaos. Don’t worry – even
                        opposites can find their perfect match. Find out how your relationship stacks up right now!
                    </p>
                    <p className="text-lg text-black mt-8">Choose your sign</p>
                </div>

                <div className="flex flex-col items-center -mt-6 justify-center mb-10">
                    <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 lg:gap-4 md:gap-4 sm:gap-1">
                        {zodiacSigns.map((sign, index) => (
                            <div
                                key={index}
                                className="flex flex-col items-center p-4 rounded-lg transition cursor-pointer"
                                onClick={() => handleSignClick(sign.name)}
                            >
                                <img
                                    src={sign.image}
                                    alt={sign.name}
                                    className="w-24 h-28 lg:w-36 lg:h-40 md:w-40 md:h-44 sm:w-24 sm:h-28 object-contain bg-bgcolor ring-4 hover:shadow-custom-shadow ring-gray-400 hover:ring-opacity-25 hover:ring-8 hover:ring-gray-300 cursor-pointer rounded-full mb-2"
                                />
                                <h2 className="text-lg font-semibold mt-2 text-primary">{sign.name}</h2>
                                <p className="text-sm text-primary">{sign.date}</p>
                            </div>
                        ))}
                    </div>
                </div>

                <main
                    className="bg-secondary container mx-auto text-white py-12"
                    ref={compatibilitySectionRef}
                >
                    <h2 className="lg:text-3xl md:text-3xl sm:text-2xl text-2xl text-white font-bold uppercase text-center mt-2">
                        {currentGroupName} Compatibility with other signs
                    </h2>
                    <h3 className="text-center font-semibold text-gray-200 text-xl mb-6">
                        Check Your Relationship Compatibility
                    </h3>

                    {currentGroupPairs.length > 0 ? (
                        <div className="px-6 lg:ml-20 lg:mr-20">
                            {/* Zodiac Pairs Grid */}
                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                                {currentGroupPairs.map((pair, index) => (
                                    <div
                                        key={index}
                                        className="flex flex-col items-center justify-center p-4 rounded-lg shadow-gray-900 shadow-md bg-white text-black"
                                        onMouseEnter={() => setIsActive(index)}
                                        onMouseLeave={() => setIsActive(null)}
                                    >
                                        <div className="flex items-center gap-2 mt-2">
                                            <img
                                                src={pair.image}
                                                alt={`${pair.pair} - 1`}
                                                className={`w-24 h-28 lg:w-28 lg:h-32 md:w-28 md:h-32 sm:w-24 sm:h-28 object-cover ring-4 shadow-lg shadow-gray-500 rounded-full ${isActive === index ? "ring-success/50" : "ring-secondary"
                                                    }`}
                                            />
                                            <img
                                                src={pair.image1}
                                                alt={`${pair.pair} - 2`}
                                                className={`w-24 h-28 lg:w-28 lg:h-32 md:w-28 md:h-32 sm:w-24 sm:h-28 object-cover ring-4 shadow-lg shadow-gray-500 rounded-full ${isActive === index ? "ring-success/50" : "ring-secondary"
                                                    }`}
                                            />
                                        </div>
                                        {/* main button */}
                                        <button
                                            className="w-auto h-9 px-4 mt-4 text-white font-semibold bg-secondary hover:shadow-md hover:shadow-gray-300 hover:bg-success rounded-full"
                                            onClick={() => handleButtonClick(pair.pair)}  // Handle button click for prediction
                                        >
                                            {pair.pair}
                                        </button>
                                    </div>
                                ))}
                            </div>

                            {/* Controls Section */}
                            <div className="flex justify-center gap-4 items-center mt-8 px-6">
                                <button
                                    onClick={handlePrev}
                                    className="flex items-center space-x-2 px-4 py-2 bg-white hover:text-secondary shadow-lg hover:shadow-gray-600 text-black font-bold rounded-full  hover:bg-gray-100"
                                >
                                    <MdOutlineKeyboardArrowLeft className="text-xl" />
                                    <span>Previous</span>
                                </button>
                                <button
                                    onClick={handleNext}
                                    className="flex items-center space-x-2 px-8 py-2 bg-white  hover:text-secondary shadow-lg hover:shadow-gray-600 text-black font-bold rounded-full  hover:bg-gray-100"
                                >
                                    <span>Next</span>
                                    <MdOutlineKeyboardArrowRight className="text-xl" />
                                </button>
                            </div>
                        </div>
                    ) : (
                        <p className="text-center text-gray-200">No compatibility data available.</p>
                    )}
                </main>
                <div className="container mx-auto mt-8  flex flex-col justify-center items-center">
                    <h1 className="text-center text-lg sm:text-xl md:text-2xl text-secondary mt-8 font-bold">
                        Recommended Reports For You
                    </h1>
                    {/* Parent Card div */}
                    <div className="flex flex-wrap gap-5 justify-center mt-5">
                        {/* Card 1 */}
                        <div className="bg-white w-full sm:w-1/2 md:w-1/3 lg:w-1/4 flex flex-col justify-between shadow-lg hover:shadow-xl h-auto p-4 rounded-lg">
                            <div className="flex flex-col items-center">
                                <img
                                    src={rings}
                                    alt="kundli.png"
                                    className="w-20 sm:w-24 md:w-28 lg:w-32 max-h-fit m-4 border rounded-xl border-white bg-white"
                                />
                                <div className="text-center">
                                    <h3 className="text-lg sm:text-xl font-bold mb-2 text-center text-secondary">Kundli Matching</h3>
                                    <p className="text-justify text-xs sm:text-sm md:text-base m-3 mb-4">
                                        Kundli Matching helps you find a match for your astrological traits and preferences. By comparing your birth
                                        chart with others in the database, you can find a person who shares your similarities, characteristics, and
                                        compatible energies.
                                    </p>
                                    <button
                                        onClick={kundliClick}
                                        className="bg-secondary w-fit h-auto p-2 sm:p-3 rounded-md hover:bg-success text-white"
                                    >
                                        Match Kundli
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Card 2 */}
                        <div className="bg-white w-full sm:w-1/2 md:w-1/3 lg:w-1/4 flex flex-col justify-between shadow-lg hover:shadow-xl h-auto p-4 rounded-lg">
                            <div className="flex flex-col items-center">
                                <img
                                    src={dailyHoroscope}
                                    alt="daily-horoscope.png"
                                    className="w-20 sm:w-24 md:w-28 lg:w-32 max-h-fit m-4 border rounded-xl border-white bg-white"
                                />
                                <div className="text-center">
                                    <h3 className="text-lg sm:text-xl font-bold mb-2 text-secondary">Daily Horoscope</h3>
                                    <p className="text-xs text-justify sm:text-sm md:text-base m-3 mb-6">
                                        Get your personalized daily horoscope and insights for the day ahead. Stay prepared and make the
                                        most of your day with astrological guidance to navigate challenges, seize opportunities, and align with cosmic energy.
                                    </p>
                                    <button
                                        onClick={horoscopeClick}
                                        className="bg-secondary w-fit h-auto p-2 sm:p-3 rounded-md hover:bg-success text-white"
                                    >
                                        View Horoscope
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Card 3 */}
                        <div className="bg-white w-full sm:w-1/2 md:w-1/3 lg:w-1/4 flex flex-col justify-between shadow-lg hover:shadow-xl h-auto p-4 rounded-lg">
                            <div className="flex flex-col items-center">
                                <img
                                    src={dailytarotImage}
                                    alt="daily-horoscope.png"
                                    className="w-20 sm:w-24 md:w-28 lg:w-32 max-h-fit m-4 border rounded-xl border-white bg-white"
                                />
                                <div className="text-center">
                                    <h3 className="text-lg sm:text-xl font-bold mb-2 text-secondary">Tarot Reading</h3>
                                    <p className="text-xs text-justify sm:text-sm md:text-base m-3 mb-4">
                                        Tarot reading provides guidance by revealing hidden energies, emotions, and possibilities. By drawing cards
                                        and interpreting meanings, you gain clarity on challenges, relationships, and opportunities. Each reading empowers
                                        you to make informed decisions.
                                    </p>
                                    <button
                                        onClick={tarotClick}
                                        className="bg-secondary w-fit h-auto p-2 sm:p-3 rounded-md hover:bg-success text-white"
                                    >
                                        Start Reading
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Queryform />
                <Footer />
            </section>
        </>
    );
};

export default LoveCompatibility;
